import laptopIcon from "../icons/laptop.svg";
import starIcon from "../icons/star.svg";
import searchIcon from "../icons/search.svg";
import brainIcon from "../icons/brain.svg";
import { useInternationalizedItems } from "../custom-hooks/useInternationalizedItems";

const iconMap: Record<string, string> = {
    laptop: laptopIcon,
    star: starIcon,
    search: searchIcon,
    brain: brainIcon,
};

type ProvideItem = {
    icon: keyof typeof iconMap;
    title: string;
};

export default function WeProvideBlock() {
    const items = useInternationalizedItems<ProvideItem[]>({
        key: "home.paragraphs.weProvideItems",
    });

    return (
        <div className="w-full mt-7 lg:mt-6 lg:w-[1280px] grid grid-cols-2 gap-4 md:gap-3 lap:grid-cols-4 lg:gap-5 lg:h-46">
            {items.map((item, index) => (
                <div
                    key={index}
                    className="w-full h-40 md:h-46 lap:h-40 bg-background-100 border border-border-400 rounded-md px-4 py-4 md:px-5 md:py-7 flex flex-col items-center text-center gap-2 md:gap-5 lg:shadow-[0px_4px_4px_0px_#36335214] lg:border-2"
                >
                    <img src={iconMap[item.icon]} alt={item.title} className="w-11 h-11 lg:w-12 lg:h-12" />
                    <p className="text-sm lg:text-lg text-text-700 font-normal">{item.title}</p>
                </div>
            ))}
        </div>
    );
}
